import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from "../../../../setup/redux/RootReducer"
import { Tabs, Tab, Button, Carousel } from 'react-bootstrap-v5'
import StoreChange from '../components/StoreChange'
import ProductSearch from '../components/ProductSearch'
import { setProductDetail } from '../redux/ProductDetailSlice'
import {ProductDetail } from '../models/productServiceModels'


//import {setCurrentStore} from '../redux/CurrentStoreSlice'
// import {GetProductList, GetProductDetail} from '../redux/ProductOperations'
// import {setProductList} from '../redux/ProductListSlice'


export default function ProductDetailPage() {
  const productDetail = useSelector((state: RootState) => state.productDetailReducer);
  const [key, setKey] = useState("");
  const dispatch = useDispatch();
const setDetail=()=>{
  dispatch(setProductDetail(new ProductDetail()));
}
  const MyCarousel = () => (
    <Carousel prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon primary" style={{ backgroundImage: 'url(https://img.icons8.com/fluency/48/000000/back.png)' }} />} nextIcon={<span aria-hidden="true" className="carousel-control-next-icon primary" style={{ backgroundImage: 'url(https://img.icons8.com/fluency/48/000000/forward.png)' }} />} nextLabel="" prevLabel="">
      {productDetail.productDetail.productImages.map((i, index) => (
        <Carousel.Item>

          <img
            className="d-block"
            style={{ height: '200px', width: 'fit-content', marginLeft: '45%', margin: 'auto' }}
            src={i.Cdn_url}
            alt="First slide"
          />
        </Carousel.Item>

      ))}
    </Carousel>

  );
  const RenderHTML = (props: any) => (<iframe width="100%" height="500px" style={{ backgroundColor: '#262638' }} srcDoc={props.HTML} />)

  useEffect(() => {
    const getActiveTab = localStorage.getItem("activeTab");
    if (getActiveTab) {
      setKey(JSON.parse(getActiveTab));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("activeTab", JSON.stringify(key));
  }, [key]);

  return (
    <div className='col-xxl-12' style={{ marginBottom: 15 }}>
      <div className={`card card-xxl-stretch`} style={{ height: 'auto', minHeight: 300, position: 'relative' }}>
        <StoreChange />
        {/* begin::Header */}
        <div className='card-header align-items-center border-0 mt-4' style={{ display: 'block', overflow: 'scroll', height: 'auto' }}>

          <ProductSearch />
        </div>
        <div className='card-toolbar'>
          <hr />
          <div className="container" style={{ marginTop: 5 }}>

            <div className="row" style={{ marginTop: '30px' }}>
              <div className="col-sm-4">
                {/* <Card style={{ alignItems: 'center' }} className="border">
              <Card.Img style={{ height: '200px', width: 'fit-content', margin: '10px' }} variant="top" src="https://cdn.metro-group.com/tr/tr_pim_442497001002_01.png" />
            </Card> */}
                <MyCarousel />
              </div>

              <div className="col">
                <div className="row">
                  <div className="col-sm" style={{ textTransform: 'uppercase' }}>
                    <span style={{ fontSize: '20px' }}>{productDetail.productDetail.productName}({productDetail.productDetail.productId})</span>
                  </div>
                </div>
                <div className="row" style={{ marginTop: '5px' }}>
                  <div className="col-sm" style={{ textTransform: 'uppercase' }}>
                    <span style={{ fontSize: '20px' }}>FİYAT: {productDetail.productDetail.price.toFixed(2)} TL* </span>{
                      (productDetail.productDetail.campaignId != 0 && productDetail.productDetail.campaingShowFlag != 0) ?
                        <span>- {productDetail.productDetail.badgeText}({productDetail.productDetail.endDate}'e kadar')</span>
                        :
                        <span></span>

                    }
                  </div>
                </div>

                <div className="row" style={{ paddingTop: '10%', width: '100%', color: 'blue' }}>
                  {(productDetail.productDetail.campaignId != 0 && productDetail.productDetail.campaingShowFlag != 0) ?
                    <div className='col-12'><span >	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-bell-fill" viewBox="0 0 16 16">
                      <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" />
                    </svg> </span>
                      <span style={{ fontSize: '12px', fontWeight: 'bold', marginLeft: '2px' }}>	 {productDetail.productDetail.campaignAnnouncement}!</span>
                    </div> :
                    <span></span>

                  }
                  <div className='col-12'><span >	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-star-fill" viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                  </svg> </span>
                    <span style={{ fontSize: '12px', fontWeight: 'bold', marginLeft: '2px' }}>	 Fiyatlar son tüketici için KDV dahildir!</span>
                  </div>
                </div>

              </div>
              <div className="col-sm-1">
                <Button variant="outline-primary border" size="sm" onClick={() =>setDetail()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-bar-left" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5zM10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5z"/>
</svg></Button>{' '}
              </div>
            </div>
            <hr />
            <div className="row" style={{ marginTop: '30px' }}>

              <div className="col-sm-4 border" style={{ marginBottom: '15px' }}
              >
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => (k != null) ? setKey(k) : null}
                  className="nav nav-tabs me-5 mb-6 mb-md-0 fs-8"

                >
                  <Tab eventKey="description" title="Ürün Açıklaması" className="nav-item">
                    {productDetail.productDetail.infoData.map(i =>
                      i.key == "Ürün Açıklaması" ? <RenderHTML HTML={i.value} /> : ""
                    )}
                  </Tab>
                  <Tab eventKey="Ingredients" title="İçindekiler" className="nav-item">
                    {productDetail.productDetail.infoData.map(i =>
                      i.key == "İçindekiler" ? <RenderHTML HTML={i.value} /> : ""
                    )}
 
                  </Tab>
                  <Tab eventKey="nutrients" title="Enerji ve Besin Öğeleri" className="nav-item">
                    {productDetail.productDetail.infoData.map(i =>
                      i.key == "Enerji ve Besin Öğeleri" ? <RenderHTML HTML={i.value} /> : ""
                    )}

                  </Tab>
                </Tabs>
              </div>
              <div className="col-sm-8">
                <table className="table table-row-dashed table-row-gray-300 gy-7">
                  <thead>
                    <tr className="fw-bolder fs-6 text-gray-800">
                      <th>Ürün Adı</th>
                      <th>Stok</th>
                      <th>Adet</th>
                      <th>Fiyat</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productDetail.productDetail.relatedStorePrices.map(x =>
                      <tr>
                        <td style={{}}><span  >{x.storeNo}-{x.storeName}</span></td>
                        <td>{x.productStockStatus == 1 ?
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style={{ color: 'green' }} className="bi bi-check2-circle" viewBox="0 0 16 16">
                            <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                            <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                          </svg>
                          : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style={{ color: 'red' }} className="bi bi-x-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                          </svg>}</td>
                        <td>{x.stockQuantity}</td>
                        <td>₺{x.price.toFixed(2)}/{productDetail.productDetail.packageType}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  )

}